import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children, skipOnboardingCheck = false }) => {
  const { isAuthenticated, loading, isOnboardingComplete, getUserBrands, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Skip onboarding check for admin users (they manage the platform, not create brands)
  const isAdmin = user?.systemRole === 'admin' || user?.systemRole === 'super_admin';

  // Check if we should redirect to onboarding
  // Skip if:
  // - explicitly told to skip (e.g., for the GetStartedPage itself, or AddBrandPage)
  // - user is an admin
  // - user is already on a route that's part of the onboarding flow
  const onboardingRoutes = ['/get-started', '/brands/new'];
  const isOnOnboardingRoute = onboardingRoutes.some(route =>
    location.pathname.startsWith(route)
  );

  if (!skipOnboardingCheck && !isAdmin && !isOnOnboardingRoute) {
    const onboardingComplete = isOnboardingComplete();
    const brands = getUserBrands();

    // Redirect to get-started if:
    // 1. User has no brands, OR
    // 2. User has brand(s) but no complete plan
    if (!onboardingComplete && brands.length === 0) {
      return <Navigate to="/get-started" replace />;
    }

    if (!onboardingComplete) {
      // User has brands but no complete plan - redirect to get-started
      return <Navigate to="/get-started" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
